import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import fr from 'vuetify/src/locale/fr';

Vue.use(Vuetify);

const opts = {
  icons: {
    // eslint-disable-next-line
    iconfont: 'md' as any,
  },
  lang: {
    locales: {fr},
    current: 'fr',
  },
  theme: {
    themes: {
      light: {
        primary: '#2B7E3A',
        secondary: '#D52F43',
        accent: '#53A356',
        error: '#f44336',
        warning: '#ff5e07',
        info: '#2196f3',
        success: '#4caf50',
      },
    },
  },
};

export default new Vuetify(opts);
